export default function Logo({ size = "md", className = "" }) {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl sm:text-3xl",
    lg: "text-4xl sm:text-5xl",
    xl: "text-5xl sm:text-6xl lg:text-7xl",
  };
  return (
    <div className={`font-serif-brand ${sizes[size]} ${className}`} data-testid="sheesh-logo">
      <span className="gold-text italic font-medium">Sheesh</span>
      <span className="text-white/90 italic font-medium"> Eatery</span>
      <span className="text-white/60 mx-1">&</span>
      <span className="text-white/90 italic font-medium">Lounge</span>
    </div>
  );
}
